// Utility functions for generating URL-safe slugs that preserve Hebrew characters for SEO

export const createSlugFromHebrew = (text: string): string => {
  return text
    .trim()
    .toLowerCase()
    // Replace spaces with hyphens
    .replace(/\s+/g, '-')
    // Remove special characters but keep Hebrew letters, English letters, numbers, and hyphens
    .replace(/[^\u0590-\u05FF\u0600-\u06FFa-z0-9\-]/gi, '')
    // Replace multiple hyphens with single hyphen
    .replace(/-+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-|-$/g, '')
    // Limit length
    .substring(0, 150);
};